import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError,setFormatedResponse } from "../services/apiService";
//check in check out
const chackInCheckOut = (params) => {
  const { axiosInstance,config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.admin.checkInCheckOut}`,
    method: "POST",
    data: params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return getFomatedError(error?.response?.data);
    });
  return response;
};

const getChackInCheckOut = (params) => {
  const { axiosInstance ,config,source} = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.admin.getCheckInCheckOut}`,
    method: "GET",
    params: params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

const getAttendanceSummary = (params) => {
  const { axiosInstance ,config,source} = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.admin.getAttendanceSummary}`,
    method: "GET",
    params: params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

const getMonthlyAttendance = (params) => {
  const { axiosInstance ,config,source} = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.admin.getMonthlyAttendance}`,
    method: "GET",
    params: params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

const getAttendanceDashboard = (params) => {
  const { axiosInstance ,config,source} = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.admin.getAttendanceDashboard}`,
    method: "GET",
    params: params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};


const getCorrectionNotification = (params) => {
  const { axiosInstance ,config,source} = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.attendance.getCorrectionNotification}`,
    method: "GET",
    params: params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

const attendanceLock = (params) => {
  const { axiosInstance ,config,source} = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.attendance.attendanceLock}`,
    method: "POST",
    data: params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

const getAttendanceLock = (params) => {
  const { axiosInstance ,config,source} = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.attendance.getAttendanceLock}`,
    method: "GET",
    params: params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

const updateAttendanceLock = (params) => {
  const { axiosInstance ,config,source} = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.attendance.updateAttendanceLock}`,
    method: "PUT",
    data: params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};


export default {
    chackInCheckOut,
    getChackInCheckOut,
    getAttendanceSummary,
    getMonthlyAttendance,
    getAttendanceDashboard,
    getCorrectionNotification,
    attendanceLock,
    getAttendanceLock,
    updateAttendanceLock
    
}